export const Collaborative = () => (
  <svg width="61" height="61">
    <defs>
      <path id="a" d="M0 .614h60.358V61H0z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g>
        <mask id="b" fill="#fff">
          <use xlinkHref="#a" />
        </mask>
        <path
          d="M30.18 2.239c-7.631 0-14.806 2.971-20.202 8.367-11.139 11.138-11.139 29.263 0 40.402 5.396 5.396 12.57 8.368 20.201 8.368 7.63 0 14.805-2.972 20.201-8.368 11.14-11.139 11.14-29.264 0-40.402C44.984 5.21 37.81 2.24 30.18 2.24m0 58.76c-8.066 0-15.649-3.14-21.351-8.842-11.772-11.773-11.772-30.927 0-42.7C14.53 3.755 22.114.614 30.179.614c8.065 0 15.649 3.141 21.35 8.843 11.772 11.773 11.772 30.927 0 42.7C45.828 57.859 38.244 61 30.18 61"
          fill="#FFF"
          mask="url(#b)"
        />
      </g>
      <path
        d="M26.576 33.962c2.983 0 5.424-2.474 5.424-5.498v-6.965C32 18.474 29.559 16 26.576 16H16.44c-2.984 0-5.425 2.474-5.425 5.499v6.965s-.492 5.498 4.091 5.498L14.625 40l5.226-5.94 6.725-.098zM47.397 20.111v-3.973c0-1.726-1.443-3.138-3.205-3.138h-5.988C36.441 13 35 14.412 35 16.138v3.973c0 1.725 1.441 3.138 3.204 3.138h7.802L50 25l-2.603-4.889zM35.878 47.645c-2.133 0-3.878-1.742-3.878-3.871V38.87A3.886 3.886 0 0 1 35.878 35h7.244A3.886 3.886 0 0 1 47 38.871v4.903s.094 3.87-2.794 3.87h-1.985L42.402 52l-3.874-4.373-2.65.018z"
        stroke="#FFF"
        strokeWidth="1.75"
      />
      <path
        d="M18 25a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM22 25a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM26 25a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
        stroke="#FFF"
        strokeWidth="1.75"
      />
    </g>
  </svg>
);
